import { trimIfString } from 'react-querybuilder';

/**
 * Removes an item from an array
 * @param array Array of items
 * @param item Item to remove
 * @returns New array without the item. The original array is not modified
 */
export const removeItem = <T>(array: readonly T[], item: T) => {
  const newArray = [...array];
  const index = newArray.indexOf(item);

  if (index > -1) {
    newArray.splice(index, 1);
  }

  return newArray;
};

/**
 * Joins the given array into a string with the "," separator.
 * @param value value of the filter
 * @returns joined string or original value
 */
export const joinIfArray = value =>
  value && Array.isArray(value) ? trimIfString(value).join(',') : trimIfString(value);
